const Header = () => {
  return (
    <div className="flex flex-col items-center justify-center pt-24 my-24 lg:my-48 gap-4 md:gap-12 lg:gap-24 ">
      <h1 className="text-4xl lg:text-6xl font-bold text-white tracking-wider">
        Jessica Barnes
      </h1>
      <h2 className="text-2xl lg:text-4xl text-white">
        Software Engineer Portfolio
      </h2>
    </div>
  );
};

export default Header;
